import { registerAgentReportContent } from './content-types/agent-report/agent-report.registration'
import { registerContentBriefContent } from './content-types/content-brief/content-brief.registration'
import { registerDomainOverviewContent } from './content-types/domain-overview.registration'
import { registerToolCallContent } from './content-types/tool-call.registration'
import { registerUserInteractionContent } from './content-types/user-interaction/user-interaction.registration'

let isInitialized = false

export const initializeSplitViewContentTypes = (): void => {
  if (isInitialized) return

  registerAgentReportContent()
  registerContentBriefContent()
  registerDomainOverviewContent()
  registerToolCallContent()
  registerUserInteractionContent()

  isInitialized = true
}

initializeSplitViewContentTypes()
